import React, { useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WhyCapDistrib from "@/components/WhyCapDistrib";
import Programme from "@/components/Programme";
import Catalogue from "@/components/Catalogue";
import Simulator from "@/components/Simulator";
import HowItWorks from "@/components/HowItWorks";
import Profiles from "@/components/Profiles";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import EnrollmentForm from "@/components/EnrollmentForm";
import ScrollReveal from "@/components/ScrollReveal";
import CookieBanner from "@/components/CookieBanner";
import PageMeta from "@/components/PageMeta";
import SeoSchemas from "@/components/SeoSchemas";

export default function LandingPage() {
    const [formOpen, setFormOpen] = useState(false);
    const [preselectedLevel, setPreselectedLevel] = useState("business_partner");

    const openForm = (level = "business_partner") => {
        setPreselectedLevel(level);
        setFormOpen(true);
    };

    return (
        <div className="min-h-screen bg-white text-cap-text">
            <PageMeta
                title="CapDistrib — Programme partenaire B2B en distribution digitale"
                description="Développe un portefeuille B2B dans la distribution de produits digitaux. Catalogue complet, back-office géré, commission récurrente. 3 niveaux de partenariat."
                canonicalPath="/"
            />
            <SeoSchemas />
            <ScrollReveal />
            <Navbar onJoin={() => openForm("business_partner")} />
            <main>
                <Hero onJoin={() => openForm("business_partner")} />
                <WhyCapDistrib />
                <Programme onJoin={openForm} />
                <Catalogue />
                <Simulator onJoin={() => openForm("business_partner")} />
                <HowItWorks />
                <Profiles />
                <FinalCTA onJoin={() => openForm("business_partner")} />
            </main>
            <Footer />
            <EnrollmentForm
                open={formOpen}
                onOpenChange={setFormOpen}
                preselectedLevel={preselectedLevel}
            />
            <CookieBanner />
        </div>
    );
}
